import React from "react";
import { PrimeIcons } from "primereact/api";
import { useHistory } from "react-router-dom";

import { TawreedAction, TawreedActionName } from "../../../../../common/actions";
import { TawreedTable, TawreedTableProps } from "../../../../../common/components/table";
import { CssUtils } from "../../../../../helpers/css";
import { Routes } from "../../../../../router";
import { TawreedTableFilters } from "../../../../../common/components/table/filters";
import { GlobalContext } from "../../../../../context";
import { TawreedTableFormatters } from "../../../../../common/components/table/formatters";
import { PaymentPartnerOnboardService } from "../../../domain/services/onboard";
import { PaymentPartnerOnboard } from "../../../domain";
import { AuthUtils } from "../../../../auth/domain";


export const PaymentPartnerOnBoardTable: React.FC = () => {
    const history = useHistory();
    const service = React.useMemo(() => new PaymentPartnerOnboardService(), []);
    const { auth:{user}, constants: { constants } } = React.useContext(GlobalContext);

    const onDetails = (sender?: PaymentPartnerOnboard): Promise<void> => {
        return new Promise((resolve, reject) => {
            if (sender && sender.paymentPartnerOnboardId) {
                history.push(Routes.PaymentPartnerOnboardDetails.replace(':id', sender.paymentPartnerOnboardId.toString()));
                resolve();
            } else {
                reject();
            }
        });
    }

    const tawreed: TawreedTableProps = {
        header: true,
        pagination: true,
        dataKey: 'paymentPartnerOnboardId',
        name: 'tbl.payment.partners.onboard',
        title: 'lbl_payment_partners_onboard',
        ds: {
            mode: 'lazy',
            onSearch: (req) => service.search(req),
        },
        columns: [
            {
                field: "paymentPartnerOnboardId",
                header: "lbl_payment_onboard_paymentPartnerOnboardId",
                sortable: true,
                filter: true,
                style: CssUtils.width('5%'),
            },
            {                
                field: "createdAt",
                header: "lbl_payment_onboard_createdat",
                sortable: true,
                filter: true,
                style: CssUtils.width('10%'),
                ...TawreedTableFilters.date.range("createdAt", 'date'),
            },
            {
                field: AuthUtils.current().language === 'en' ? "paymentPartnerTitleEn" : "paymentPartnerTitleAr",
                header: "lbl_payment_onboard_payment_partner",
                sortable: true,
                sortField: 'paymentPartnerTitleEn',
                filter: true,
                filterField: 'paymentPartnerTitleEn',
                style: CssUtils.width('20%'),
            },
            {
                field: "customerName",
                header: "lbl_payment_onboard_partner_name",
                sortable: true,
                sortField: 'customerName',
                filter: true,
                filterField: 'customerName',
                style: CssUtils.width('20%'),
            },
            {
                field: "name",
                header: "lbl_payment_onboard_name",
                sortable: true,
                sortField: 'name',
                filter: true,
                filterField: 'name',
                style: CssUtils.width('10%'),
            },
            {
                field: "limit",
                header: "lbl_payment_onboard_limit",
                sortable: true,
                filter: true,
                style: CssUtils.width('5%'),
                //...TawreedTableFormatters.decimal('limit',user?.scale, undefined, CssUtils.width('15%')),
            },
            {
                field: "status",
                header: "lbl_payment_onboard_status",
                sortable: true,
                filter: true,
                style: CssUtils.width('15%'),
                //...TawreedTableFilters.dropdown.dropdown("status", constants && constants.paymentransactionStatuses ? constants.paymentransactionStatuses : [], 'value', 'label', 'in'),
            },
        ],
        row: {
            onClick: new TawreedAction(TawreedActionName.PaymentPartnerOnBoardDetails, 'statefull', 'lbl_info', PrimeIcons.INFO, onDetails, 'p-button-secondary', false),
        },
        filter: {
            filterDisplay: 'menu',
            initial: {
                'paymentPartnerOnboardId': {
                    operator: 'AND',
                    constraints: [
                        {
                            value: null,
                            matchMode: 'equals',
                        },
                    ]
                },
                'createdAt': {
                    operator: 'AND',
                    constraints: [
                        {
                            value: null,
                            matchMode: 'dateIs',
                        },
                    ]
                },
                'paymentPartnerTitleEn': {
                    operator: 'AND',
                    constraints: [
                        {
                            value: null,
                            matchMode: 'contains',
                        },
                    ]
                },
                'paymentPartnerTitleAr': {
                    operator: 'AND',
                    constraints: [
                        {
                            value: null,
                            matchMode: 'contains',
                        },
                    ]
                },
                'customerName': {
                    operator: 'AND',
                    constraints: [
                        {
                            value: null,
                            matchMode: 'contains',
                        },
                    ]
                },
                'name': {
                    operator: 'AND',
                    constraints: [
                        {
                            value: null,
                            matchMode: 'contains',
                        },
                    ]
                },
                'limit': {
                    operator: 'AND',
                    constraints: [
                        {
                            value: null,
                            matchMode: 'equals',
                        },
                    ]
                },
                'status': {
                    operator: 'AND',
                    constraints: [
                        {
                            value: null,
                            matchMode: 'equals',
                        },
                    ]
                },                
            },
        },
        sort: {
            sortMode: 'single',
            initial: {
                sortField: 'createdAt',
                sortOrder: -1,
                multiSortMeta: undefined,
            },
        },
        selection: {
            mode: 'checkbox',
        },
    }
    return (<TawreedTable  {...tawreed} />);
}